import React, { Component } from "react";
import BuyButton from "./BuyButton";
import Price from "./Price";

const LeftSide = () => (
	<div className="flight-row">
		<i className="icon-bus" />
		<div>
			<h3 className="bus-city no-margin">Confira também passagem de ônibus</h3>
			<p className="bus-city no-margin">Preços acessiveis</p>
		</div>
	</div>
);

const Luggage = () => (
	<div className="dispatch-luggage not-included">
		<span>
			<i className="icon icon-bad-on-board"></i>Apenas bagagem de mão incluída
		</span>
	</div>
);

class BusCardV2 extends Component {
	render() {
		const { route, ...rest } = this.props;

		return (
			<div className="flight-item bus-item-v2 bus-item">
				<div className="container-fluid">
					<div className="row">
						<div className="col-xs-16 col-md-10 v-center-columns">
							{route ? <LeftSide /> : <div className="lazyload" />}
						</div>
						<div className="col-xs-16 col-md-2 v-center-columns flight-item-price">
							{route ? (
								<div className="highlight-price">
									<Price price={route.preco} />
								</div>
							) : (
								<div className="lazyload" />
							)}
						</div>
						<div className="col-xs-16 col-md-4 v-center-columns flight-item-price">
							{route ? <BuyButton { ...rest } /> : <div className="lazyload" />}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default BusCardV2;
